export function toViewAll(programSlug: string, type: string): string {
  return `/programs/${programSlug}/view-all-collections/${type}`;
}
